import { useUsers } from "../users/useAllUsers";
import { useRoles } from "../roles/useRoles";
import { useConfigurables } from "../configurables/useConfigurables";
import { locationRegisterRoutes } from "../../components/pages/location/LocationRoute";
// import { useAuditTrail } from "../audits/useAuditTrail";
import { officesRegisterRoutes } from "../../components/pages/offices/OfficesRoutes";
import { useLoanApplication } from "../loan_applications/useLoanApplication";
import { useInterestConfigurables } from "../configurables/useInterestConfigurables";
import { usePeriodConfigurables } from "../configurables/usePeriodConfigurables";
import { useLedgers } from "../ledgers/useLedgers";
import { useFeesConfigurables } from "../configurables/useFeesConfigurables";
import { useInstalment } from "../instalments/useInstalments";
import { useSupplierConfigurables } from "../configurables/useSupplierConfigurables";
import { usePurchaseOrder } from "../purchase_orders/usePurchaseOrder";
import { useInventory } from "../inventory/useInventory";
import { useInventoryPurchaseOrder } from "../purchase_orders/useInventoryPurchaseOrder";
import { usePurchaseOrderItems } from "../purchase_orders/usePurchaseOrderItems";
import { useProduct } from "../inventory/useProduct";
import { usePayroll } from "../payroll/usePayroll";
import { useAllowanceTypeConfigurables } from "../configurables/useAllowanceTypeConfigurables";
import { useExpense } from "../expenses/useExpense";
import { useOtherIncome } from "../other_income/useOtherIncome";
import { useOrganisations } from "../organisations/useOrganisations";
import { useInvoices } from "../invoices/useInvoices";
import { usePRNs } from "../invoices/usePRNs";
import { useRequisition } from "../requisition/useRequisition";
import { useLoanApplicationDrafts } from "../loan_applications/useLoanApplicationDrafts";
import { usePayments } from "../payments/usePayments";
import { useReschedule } from "../loan_applications/reshedule/useReschedule";
import { usePaymentModesConfigurables } from "../configurables/usePaymentModesConfigurables";
import { useApplicationUsers } from "../users/useApplicationUsers";
import { usePaymentItems } from "../accounting/usePaymentItems";
import { useYoyaCharges } from "../services/charges/useYoyaCharges";
import { usePartners } from "../accounting/usePartners";
import { useMerchantFees } from "../agent_management/useMerchantFees";
import { usePartnerCharges } from "../accounting/usePartnerCharges";
import { usePaymentServices } from "../payment_services/usePaymentServices";
import { useWalletTransfers } from "../wallet_transfers/useWalletTransfers";
import { usePaymentTypes } from "../accounting/usePaymentTypes";
import { useReverseTransactions } from "../transaction_processing/useReverseTransactions";
import { usePartnerItemMapping } from "../transaction_processing/usePartnerItemMapping";
import { useMarkTransaction } from "../transaction_processing/useMarkTransaction";
import { useWorkflows } from "../workflows/useWorkflows";
import { useScrutinyWorkflows } from "../workflows/useScrutinyWorkflows";
import { useMerchantServiceAccess } from "../agent_management/useMerchantServiceAccess";
import { useMerchantIPWhitelist } from "../agent_management/useMerchantIPWhitelist";
import { useChargeAssignment } from "../accounting/useChargeAssignment";
import { useReconciliationsReports } from "../reconciliations/useReconciliationsReports";
import { useInternalMerchantAccess } from "../internal_merchant_access/useInternalMerchantAccess";
import { useMerchantUsers } from "../users/useMerchantUsers";
import { useTransactionMonitoring } from "../reconciliations/useTransactionMonitoring";
import { useReconciliationStatements } from "../reconciliations/useReconciliationStatement";
import { useSystemWallets } from "../accounting/useSystemWallets";
import { useLiquidationsConfigurables } from "../configurables/useLiquidationsConfigurables";
import { useDynamicQRcode } from "../qr_codes/useDynamicQRcode";
import { useMerchantCodes } from "../agent_management/useMerchantCodes";
import { useFraudRules } from "../fraud_detection/useFraudRules";
import { useAgents } from "../users/useAgents";
import { useMerchants } from "../users/useMerchants";
import { usePublicUsers } from "../users/usePublicUsers";
import { useQRcodePayments } from "../qr_codes/useQRcodePayments";
import { useFraudEvents } from "../fraud_detection/useFraudEvents";
import { useFraudRulesHistory } from "../fraud_detection/useFraudRulesHistory";
import { useMerchantPayments } from "../agent_management/useMerchantPayments";
import useFraudAuditLogs from "../fraud_detection/useFraudAuditLogs";
import { useFraudWeightScore } from "../fraud_detection/useFraudWeightScore";
import { useFraudAlerts } from "../fraud_detection/useFraudAlerts";
import { useFraudCases } from "../fraud_detection/useFraudCases";
import { useFraudTemplates } from "../fraud_detection/useFraudTemplates";
import { useFraudConfigurations } from "../fraud_detection/useFraudConfigurations";
import { useStaffs } from "../users/useStaffs";
import { useRejectedApplicationUsers } from "../users/useRejectedApplicationUsers";
import { useIframePayments } from "../payments/useIframePayments";
import { useUSSDInputlogs } from "../ussd_services/useUSSDInputLogs";
import { useUSSDCustomerTransactions } from "../ussd_services/useUSSDCustomerTransactions";
import { useUSSDIncomingLogs } from "../ussd_services/useUSSDIncomingLogs";
import { useUSSDOutgoingLogs } from "../ussd_services/useUSSDOutgoingLogs";
import { useEnquiries } from "../contact_us/useEnquiries";
import { useMonitoredAccounts } from "../float_management/useMonitoredAccounts";
import { useAccountAlerts } from "../float_management/useAccountAlerts";
import { useCreditHoldingTypes } from "../float_management/useCreditHoldingTypes";
import { useDebitHoldingTypes } from "../float_management/useDebitHoldingTypes";
import { useLiquidationBankCodes } from "../float_management/useLiquidationBankCodes";
import { useTrialBalance } from "../trial_balance/useTrialBalance";
import { useTransactionChannelSeparation } from "../transaction_channel_separation/useTransactionChannelSeparation";
import { useBankAccounts } from "../float_management/useBankAccounts";
import { useReplenishment } from "../float_management/useReplenishment";
import { useLiquidations } from "../float_management/useLiquidations";
import { useDebitHolding } from "../float_management/useDebitHolding";
import { useCreditHolding } from "../float_management/useCreditHolding";
import { useCompositeItems } from "../composite_items/useCompositeItems";
import { usePartnerCommissionSummary } from "../partner_commission_summary/usePartnerCommissionSummary";
import { useAgentCommissionSummary } from "../agent_commission_summary/useAgentCommissionSummary";
import { useYoyaCommissionSummary } from "../yoya_commission_summary/useYoyaCommissionSummary";
import { useUtilityTransactions } from "../../components/pages/utility_payments/useUtilityTransactions";
import { useFloatInterestConfigs } from "../finance_and_treasury/revenue_sharing/useFloatInterestConfigs";
import useFloatInterestStatements from "../finance_and_treasury/revenue_sharing/useFloatInterestStatements";
import { useSettlementBatches } from "../finance_and_treasury/settlement_engine/useSettlementBatches";
import { useSettlementRules } from "../finance_and_treasury/settlement_engine/useSettlementRules";
import { useSettlementBeneficiaries } from "../finance_and_treasury/settlement_engine/useSettlementBeneficiaries";
import { useSettlementApprovals } from "../finance_and_treasury/settlement_engine/useSettlementApprovals";
import { useSecurityAudit } from "../audits/useSecurityAudit";
import { useBusinessAuditLogs } from "../audits/useBusinessAuditLogs";
import { useIncidentTicketing } from "../incident_ticketing/useIncidentTicketing";
import { useTicketCategorization } from "../ticket_categorization/useTicketCategorization";
import { useRaisedTickets } from "../raised_tickets/useRaisedTickets";
import { useAssignedTickets } from "../assigned_tickets/useAssignedTickets";
import { useIncidentTicketCategory } from "../incident_ticket_category/useIncidentTicketCategory";
import { useIncidentTicketSeverity } from "../incident_ticket_severity/useIncidentTicketSeverity";
import { useUSSDSafeguards } from "../ussd_safeguards/useUSSDSafeguards";
import { useOutgoingRequests } from "../disbursement_service/useOutgoingRequests";
import { useIncomingRequests } from "../disbursement_service/useIncomingRequests";
import { useTransactionLogs } from "../disbursement_service/useTransactionLogs";
import { useCustomerDetails } from "../disbursement_service/useCustomerDetails";
import { useErrorLogs } from "../disbursement_service/useErrorLogs";
import { useQRcodeReceiptConfigurations } from "../qr_codes/useQRcodeReceiptConfigurations";
import { useQRcodeMerchantServices } from "../qr_codes/useQRcodeMerchantServices";
import {
  useMerhantConfigurablesBusiness,
  useMerhantConfigurablesindustry,
} from "../configurables/useMerhantConfigurables";

// handle register creation
export const registerHooks: Record<string, any> = {
  users: useUsers,
  merchants: useMerchants,
  agents: useAgents,
  public_users: usePublicUsers,
  staff_users: useStaffs,
  application_users: useApplicationUsers,
  rejected_application_users: useRejectedApplicationUsers,
  // ROLES
  roles: useRoles,
  // TRANSACTION PROCESSING
  // reversal_requests: useTransactionReversals,
  partner_item_mapping: usePartnerItemMapping,
  liquidations: useLiquidations,
  monitored_accounts: useMonitoredAccounts,
  account_alerts: useAccountAlerts,
  credit_holding_types: useCreditHoldingTypes,
  debit_holdings_types: useDebitHoldingTypes,
  liquidation_bank_codes: useLiquidationBankCodes,
  bank_accounts: useBankAccounts,
  debit_holdings: useDebitHolding,
  credit_holdings: useCreditHolding,
  // Temp
  reverse_transactions: useReverseTransactions,
  mark_transaction: useMarkTransaction,

  // CONFIGURABLES
  configurables: useConfigurables,
  interest_configurables: useInterestConfigurables,
  period_configurables: usePeriodConfigurables,
  fees_schedule_configurables: useFeesConfigurables,
  supplier_configurables: useSupplierConfigurables,
  allowance_types_configurables: useAllowanceTypeConfigurables,
  payment_modes_configurables: usePaymentModesConfigurables,
  merchant_industries_configurables: useMerhantConfigurablesindustry,
  merchant_business_configurables: useMerhantConfigurablesBusiness,
  // LOAN APPLICATIONS
  loan_application: useLoanApplication,
  loan_application_drafts: useLoanApplicationDrafts,
  loan_application_reschedule: useReschedule,
  instalments: useInstalment,
  // payroll
  payrolls: usePayroll,
  // inventory mgt
  ledgers: useLedgers,
  purchase_order: usePurchaseOrder,
  purchase_order_items: usePurchaseOrderItems,
  inventory_purchase_order: useInventoryPurchaseOrder,
  inventory: useInventory,
  products: useProduct,
  expenses: useExpense,
  requisitions: useRequisition,
  other_income: useOtherIncome,
  invoices: useInvoices,
  prns: usePRNs,
  // MASTER DATA
  ...locationRegisterRoutes,
  // AUDIT TRAIL
  // audit_activity: useAuditTrail,
  security_activity: useSecurityAudit,
  business_audit_logs: useBusinessAuditLogs,
  // OFFICES
  ...officesRegisterRoutes,
  // SERVICES
  payment_items: usePaymentItems,
  partners: usePartners,
  merchant_fees: useMerchantFees,
  merchant_service_access: useMerchantServiceAccess,
  merchant_ip_whitelist: useMerchantIPWhitelist,
  //CHARGES
  yoya_charges: useYoyaCharges,
  partner_charges: usePartnerCharges,
  charge_assignment: useChargeAssignment,

  payments: usePayments,
  // ORGANISATIONS
  organisations: useOrganisations,

  //PAYMENT SERVICES
  payment_services: usePaymentServices,
  composite_items: useCompositeItems,

  //PAYMENT SERVICES
  wallet_transfers: useWalletTransfers,

  //PAYMENT SERVICES
  payment_types: usePaymentTypes,

  //FLOAT MANAGEMENT
  replenishment: useReplenishment,

  //WORKFLOWS
  workflows: useWorkflows,
  scrutiny_workflows: useScrutinyWorkflows,

  //RECONCILIATIONS REPORTS
  reconciliations_reports: useReconciliationsReports,

  //PAYMENT ACCESS MATRIX
  internal_merchant_access: useInternalMerchantAccess,

  //MERCHANT USERS
  merchant_users: useMerchantUsers,
  transaction_monitoring: useTransactionMonitoring,
  reconciliation_statements: useReconciliationStatements,

  //SYSTEM WALLETS
  system_wallets: useSystemWallets,

  //FINANCE AND TREASURY
  float_interest_configs: useFloatInterestConfigs,
  float_interest_statements: useFloatInterestStatements,
  settlement_batches: useSettlementBatches,
  settlement_rules: useSettlementRules,
  settlement_beneficiaries: useSettlementBeneficiaries,
  settlement_approvals: useSettlementApprovals,

  //UTILITY TRANSACTIONS
  utility_transactions: useUtilityTransactions,

  //LIQUIDATION CONFIGURABLE
  liquidation_configurations: useLiquidationsConfigurables,

  // QR CODES
  dynamic_qr_code: useDynamicQRcode,
  qr_code_payments: useQRcodePayments,
  qr_code_receipt_configurations: useQRcodeReceiptConfigurations,
  qr_code_merchant_services: useQRcodeMerchantServices,

  //MERCHANT CODES
  merchant_codes: useMerchantCodes,

  // FRAUD DETECTION
  fraud_rules: useFraudRules,
  fraud_events: useFraudEvents,
  fraud_rules_history: useFraudRulesHistory,
  fraud_audit_logs: useFraudAuditLogs,
  fraud_weight_score: useFraudWeightScore,
  fraud_alerts: useFraudAlerts,
  fraud_cases: useFraudCases,
  fraud_templates: useFraudTemplates,
  fraud_configurations: useFraudConfigurations,

  // MERCHANT PAYMENTS
  merchant_payments: useMerchantPayments,

  //IFRAME PAYMENTS
  iframe_payments: useIframePayments,

  //USSD SERVICES
  ussd_input_logs: useUSSDInputlogs,
  ussd_customer_transactions: useUSSDCustomerTransactions,
  ussd_incoming_logs: useUSSDIncomingLogs,
  ussd_outgoing_logs: useUSSDOutgoingLogs,
  ussd_safeguards: useUSSDSafeguards,

  //SUMMARY REPORTS
  partner_commission_summary: usePartnerCommissionSummary,
  agent_commission_summary: useAgentCommissionSummary,
  yoya_commission_summary: useYoyaCommissionSummary,

  //REPORTS
  trial_balance: useTrialBalance,
  transaction_channel_separation: useTransactionChannelSeparation,
  incident_ticket_category: useIncidentTicketCategory,
  incident_ticket_severity: useIncidentTicketSeverity,

  //DISBURSEMENTS
  outgoing_requests: useOutgoingRequests,
  incoming_requests: useIncomingRequests,
  transaction_logs: useTransactionLogs,
  customer_details: useCustomerDetails,
  error_logs: useErrorLogs,

  //SUPPORT
  incident_ticketing: useIncidentTicketing,
  ticket_categorization: useTicketCategorization,
  raised_tickets: useRaisedTickets,
  assigned_tickets: useAssignedTickets,

  //CONTACT US
  enquiries: useEnquiries,
};
